import { Routes } from "@angular/router";
import { MainComponent } from "./pages/main/main.component";

export const routes: Routes = [
    { path: "", component: MainComponent },
    { path: "rooms", loadComponent: () => import("./pages/rooms/rooms.component").then((component) => component.RoomsComponent) },
    { path: "contact", loadComponent: () => import("./pages/contact/contact.component").then((component) => component.ContactComponent) },
    { path: "book", loadComponent: () => import("./pages/book/book.component").then((component) => component.BookComponent) },
    {
        path: "booking/:bookingNumber",
        loadComponent: () => import("@estatex/components").then((component) => component.ViewBookingComponent),
    },
];
